import { useTheme } from "@/hooks/useTheme";
import { StyleSheet, View, ViewStyle } from "react-native";
import { Button, ButtonProps } from "@/components/ui/Button";
import useContextMenu from "@/hooks/useContextMenu";
import { useRef } from "react";

export type MenuProps = {
  style?: ViewStyle;
  buttonStyle?: ButtonProps["style"];
  canEdit?: boolean;
  canArchive?: boolean;
  canDuplicate?: boolean;
  canDelete?: boolean;
  hideEdit?: boolean;
  hideArchive?: boolean;
  hideDuplicate?: boolean;
  hideDelete?: boolean;
  onEdit?: () => void;
  onArchive?: () => void;
  onDuplicate?: () => void;
  onDelete?: () => void;
};
export function Menu({
  style,
  buttonStyle,
  canEdit = true,
  canArchive = true,
  canDuplicate = true,
  canDelete = true,
  hideEdit = false,
  hideArchive = false,
  hideDuplicate = false,
  hideDelete = false,
  onEdit,
  onArchive,
  onDuplicate,
  onDelete,
}: MenuProps) {
  const { colors } = useTheme();
  const contextMenu = useContextMenu();
  const ref = useRef<View>(null);

  const handleEdit = () => {
    onEdit?.();
    contextMenu.setVisible(false);
  };

  const handleArchive = () => {
    onArchive?.();
    contextMenu.setVisible(false);
  };

  const handleDuplicate = () => {
    onDuplicate?.();
    contextMenu.setVisible(false);
  };

  const handleDelete = () => {
    onDelete?.();
    contextMenu.setVisible(false);
  };

  const menuContent = (
    <View style={[styles.menu, { backgroundColor: colors.background, borderColor: colors.border }]}>
      {!hideEdit && (
        <Button
          text="Edit"
          enabled={canEdit}
          iconSize={18}
          icon="pencil"
          style={styles.menuItems}
          onPress={handleEdit}
        />
      )}
      {!hideArchive && (
        <Button
          text="Archive"
          enabled={canArchive}
          iconSize={18}
          icon="archive-arrow-down"
          style={styles.menuItems}
          onPress={handleArchive}
        />
      )}
      {!hideDuplicate && (
        <Button
          text="Duplicate"
          enabled={canDuplicate}
          iconSize={18}
          icon="content-duplicate"
          style={styles.menuItems}
          onPress={handleDuplicate}
        />
      )}
      {!hideDelete && (
        <Button
          text="Delete"
          enabled={canDelete}
          textStyle={(state) => ({
            color: state.hovered ? colors.dangerText : colors.red.border,
          })}
          iconStyle={(state) => ({
            color: state.hovered ? colors.dangerText : colors.red.border,
          })}
          hoverColor={colors.dangerBackground}
          iconSize={18}
          icon="trash-can"
          style={styles.menuItems}
          onPress={handleDelete}
        />
      )}
    </View>
  );
  return (
    <Button
      style={() => [styles.button, {}, buttonStyle]}
      ref={ref}
      icon="dots-horizontal"
      onPress={() => {
        contextMenu.setIgnoreRef(ref);
        ref.current?.measureInWindow((pageX, pageY) => contextMenu.setLocation({ x: pageX - 80, y: pageY + 30 }));
        contextMenu.setMenuContent(menuContent);
        contextMenu.setVisible((p) => !p);
        contextMenu.setStyle({ backgroundColor: colors.background, overflow: "hidden" });
      }}
    />
  );
}
const styles = StyleSheet.create({
  button: {
    width: 25,
  },
  menu: {
    borderWidth: 0,
  },
  menuItems: {
    backgroundColor: "transparent",
    borderWidth: 0,
    justifyContent: "flex-start",
    gap: 8,
  },
});
